import { AgentSitefService } from 'congress/shared/layout/checkout/agent-sitef/agent-sitef.service';
import { TerminalSettingsService } from 'congress/shared/layout/terminal/terminal-settings.service';
import { CartHelperService } from './../../../../app/store/cart/cart-helper-service';
import { Component, Injectable, Injector, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AppAuthService } from "@app/shared/common/auth/app-auth.service";
import { AppConsts } from "@shared/AppConsts";
import { AppComponentBase } from "@shared/common/app-component-base";
import { AppSessionService } from "@shared/common/session/app-session.service";
import {
    GetCurrentLoginInformationsOutput,
    ProfileServiceProxy,
    SessionServiceProxy,
    TenantLoginInfoDto,
    UserLinkServiceProxy,
} from "@shared/service-proxies/service-proxies";
import { CookieService } from "@shared/utils/cookie.service";
import { AbpSessionService } from "abp-ng2-module/src/session/abp-session.service";
import { TerminalSettingsModalComponent } from "../terminal/terminal-settings-modal.component";
import { CheckoutModalComponent } from '../checkout/checkout-modal/checkout-modal.component';

@Component({
    selector: "header-top-bar",
    templateUrl: "./header-top-bar.component.html",
    styleUrls: [
        "./header-top-bar.component.css",
        "../../common/styles/congress.css",
    ],
})
@Injectable()
export class HeaderTopBarComponent extends AppComponentBase implements OnInit {
    @ViewChild("terminalSettingsModal")
    terminalSettingsModal: TerminalSettingsModalComponent;
    @ViewChild('checkoutmodal') checkoutmodal: CheckoutModalComponent;

    shownLoginNameTitle = "";
    shownLoginName = "";
    userName = "";

    profilePicture =
        AppConsts.appBaseUrl +
        "/assets/common/images/default-profile-picture.png";
    defaultLogo =
        AppConsts.appBaseUrl +
        "/assets/common/images/app-logo-on-" +
        this.ui.getAsideSkin() +
        ".png";

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    chatConnected = false;

    tenant: TenantLoginInfoDto = new TenantLoginInfoDto();

    userLogged = this.appSession.user;

    showProgrammings: boolean = false;
    showEventWorks: boolean = false;
    terminalConfigured:boolean = undefined;

    constructor(
        injector: Injector,
        private _abpSessionService: AbpSessionService,
        private _profileServiceProxy: ProfileServiceProxy,
        private _userLinkServiceProxy: UserLinkServiceProxy,
        private _authService: AppAuthService,
        private _sessionService: SessionServiceProxy,
        private _appSessionService: AppSessionService,
        private _cookieService: CookieService,
        private _cartService: CartHelperService,
        private _terminalSettingsService: TerminalSettingsService,
        private _agentSitefService: AgentSitefService,
        private router: Router
    ) {
        super(injector);
    }

    ngOnInit() {

        this.terminalConfigured = this._terminalSettingsService.isConfigured();

        if (this.userLogged) {
            this.getCurrentLoginInformations();
            this.getProfilePicture();
        }
    }

    ngAfterViewInit(){
        if(!this.terminalConfigured){

            if(this.permission.isGranted('Pages.Congress.TerminalSettings.Edit')){
                this.terminalSettingsModal.show();

                this.notify.error('Administrador, configure o terminal para utilização. <i _ngcontent-c1="" class="fa fa-gear" style="font-size: 1.5rem;"></i>','Terminal não configurado', { timeOut: 3000000, closeButton: true });
            }
            else{
                this.notify.error('Solicite ao administrador a configuração o terminal para utilização. <i _ngcontent-c1="" class="fa fa-gear" style="font-size: 1.5rem;"></i>','Terminal não configurado', { timeOut: 3000000, closeButton: true });
            }
        }
    }

    getCurrentLoginInformations(): void {
        this.shownLoginName = this.appSession.getShownLoginFirstName();
        this.userName = this.appSession.user.userName;

        this._sessionService
            .getCurrentLoginInformations()
            .subscribe((result: GetCurrentLoginInformationsOutput) => {
                this.tenant = result.tenant;
            });
    }

    getProfilePicture(): void {
        this._profileServiceProxy.getProfilePicture().subscribe((result) => {
            if (result && result.profilePicture) {
                this.profilePicture =
                    "data:image/jpeg;base64," + result.profilePicture;
            }
        });
    }

    showCheckout(){

        this.checkoutmodal.show();
    }

    //Exit
    logout(): void {
        this._authService.logout(
            true,
            AppConsts.appBaseUrl + "/congresso/home"
        );
        localStorage.removeItem("showRegistrationMessage");
        this._cartService.clearCart();
        this._agentSitefService.clearSitefStorage();
    }

    changeTerminalSettings(): void {
        this.terminalSettingsModal.show();
    }

    onTerminalSettingsModalSaved() {
        this.notify.info(this.l("SavedSuccessfully"));
    }

    isCongressHomeLayout(): boolean {
        return this.router.url.indexOf("/congresso/home") >= 0;
    }


}



// WEBPACK FOOTER //
// ./src/congress/shared/layout/header-top-bar/header-top-bar.component.ts